<template>
  <div class="grid-x return-details-summary margin-top-m">
    <div class="cell small-12 medium-5 h5 margin-bottom-s">Return Complete</div>
    <p class="margin-bottom-s">
      Your return is complete and your refund was issued. Depending on your bank, it may take a few days for your refund to appear.
    </p>
    <p>You can donate, keep, or recycle your items.</p>
  </div>
  <div class="h5 padding-top-m">Return Details</div>
  <div class="padding-top-s">
    <div class="grid-x">
      <div class="cell small-5 medium-6">Return submitted on</div>
      <div class="cell small-7 medium-6 text-right medium-text-left">
        {{ returnSubmittedOn }}
      </div>
    </div>
    <div class="grid-x">
      <div class="cell small-5 medium-6">Refund to</div>
      <div class="cell small-7 medium-6 text-right medium-text-left">
        <p v-if="estimatedCreditResponse?.giftCardMessageFlag" class="label">Macy's Gift Card</p>
        <p v-if="estimatedCreditResponse?.originalPaymentFlag" class="label">
          {{ estimatedCreditResponse?.refundToAccount }}
        </p>
        <p v-if="estimatedCreditResponse?.refundToOriginalPaymentFlag" class="label">
          {{ estimatedCreditResponse?.refundToOriginalPayment }}
        </p>
      </div>
    </div>
    <div class="grid-x">
      <div class="cell small-5 medium-6">Estimated refund</div>
      <div class="cell small-7 medium-6 text-right medium-text-left">
        {{ estimatedRefund }}
      </div>
    </div>
    <div class="grid-x">
      <div class="cell small-5 medium-6">Order #</div>
      <div class="cell small-7 medium-6 text-right medium-text-left" role="img" :aria-label="`${orderNumber?.split('').join(' ')}`">
        {{ orderNumber }}
      </div>
    </div>
    <div class="grid-x">
      <div class="cell small-5 medium-6">Return ID</div>
      <div class="cell small-7 medium-6 text-right medium-text-left">
        {{ returnID }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatPrice } from '@/utils/returns/General';
import { formatDate } from '@/utils/General';
import estimatedCredit from '@/utils/returns/EstimatedCredit';

const props = defineProps({
  returnDetails: {
    type: Object,
    default() {
      return {};
    },
  },
});

const estimatedCreditResponse = computed(() => {
  return estimatedCredit(props.returnDetails, true);
});

const returnSubmittedOn = computed(() => {
  return formatDate(props.returnDetails.rpShipments?.[0]?.returnSubmittedDate);
});

const estimatedRefund = computed(() => {
  return formatPrice(props.returnDetails.rpShipments?.[0]?.estimatedRefund);
});

const orderNumber = computed(() => {
  return props.returnDetails.orderNumber;
});

const returnID = computed(() => {
  return props.returnDetails.rpShipments?.[0]?.rmaId;
});
</script>

<style lang="scss" scoped></style>
